const NotFound = () => {
    return(
        <div>
            <p className="text-4xl">404</p>
        </div>
    )
}

export default NotFound